import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import BaseStore from "./BaseStore";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import OrderBySearchStates from "../constants/states/OrderBySearchStates";


class SearchFiltersState {
    constructor(
        minPrice,
        maxPrice,
        orderBy,
        distance,
        zoomLevel) {
        this.minPrice = minPrice;
        this.maxPrice = maxPrice;
        this.orderBy = orderBy;
        this.distance = distance;
        this.zoomLevel = zoomLevel;
    }

    equals(other) {
        return this.minPrice === other.minPrice &&
                this.maxPrice === other.maxPrice &&
                this.orderBy === other.orderBy &&
                this.distance === other.distance &&
                this.zoomLevel === other.zoomLevel;
    }
}

class ImmutableSearchFiltersStateBuilder {

    constructor() {
        this.minPrice = 0;
        this.maxPrice = 100;
        this.orderBy = OrderBySearchStates.DISTANCE_CLOSEST;
        this.distance = 7.63;
        this.zoomLevel = 13;
    }

    setFromState(state) {
        return this.setMinPrice(state.minPrice)
            .setMaxPrice(state.maxPrice)
            .setOrderBy(state.orderBy)
            .setZoomLevel(state.zoomLevel)
            .setDistance(state.distance);
    }

    setMinPrice(minPrice) {
        this.minPrice = minPrice;
        return this;
    }

    setMaxPrice(maxPrice) {
        this.maxPrice = maxPrice;
        return this;
    }

    setOrderBy(orderBy) {
        this.orderBy = orderBy;
        return this;
    }

    setDistance(distance) {
        this.distance = parseFloat(distance);
        return this;
    }

    setZoomLevel(zoomLevel) {
        this.zoomLevel = zoomLevel;
        return this;
    }

    build() {
        return Object.freeze(
            new SearchFiltersState(this.minPrice, this.maxPrice, this.orderBy, this.distance, this.zoomLevel));
    }
}


class SearchFiltersStore extends BaseStore {

    constructor() {
        super(StoreUpdateEvents.SERP_STORE_UPDATED, ImmutableSearchFiltersStateBuilder);
        this.subscribeToEvent(UIInteractionEvents.MIN_PRICE_CHANGED, this.handleMinPriceChanged);
        this.subscribeToEvent(UIInteractionEvents.MAX_PRICE_CHANGED, this.handleMaxPriceChanged);
        this.subscribeToEvent(UIInteractionEvents.ORDER_BY_CHANGED, this.handleOrderByChanged);
        this.subscribeToEvent(UIInteractionEvents.MAP_ZOOM_CHANGED, this.handleZoomChanged);

    }

    handleMinPriceChanged = (topic, data) => {
        return new ImmutableSearchFiltersStateBuilder()
            .setFromState(this.state)
            .setMinPrice(data)
            .build();
    }

    handleMaxPriceChanged = (topic, data) => {
        return new ImmutableSearchFiltersStateBuilder()
            .setFromState(this.state)
            .setMaxPrice(data)
            .build();
    }

    handleOrderByChanged = (topic, data) => {
        return new ImmutableSearchFiltersStateBuilder()
            .setFromState(this.state)
            .setOrderBy(Symbol(data))
            .build();
    }

    handleZoomChanged = (topic, data) => {
        return new ImmutableSearchFiltersStateBuilder()
            .setFromState(this.state)
            .setDistance(data.distance)
            .setZoomLevel(data.zoomLevel)
            .build();
    }

}

export default new SearchFiltersStore();